import { baseAPI } from 'api/instance';
import { apiErrorHandler } from 'api';

//// 1) 메시지 수동 발송
// 1. 메시지 수동 발송 조회(기존 꺼로 요청 처리)
export const getManualList = async (props: TRequestManualListParams) => {};
// 2. 메시지 수동 발송 발송하기(POST)
type TcustomerInfo = {
  customer_name: string;
  customer_phone: string;
  messageReceiverId?: number | null;
  messageId?: number | null;
  createdAt?: string | null;
};
type TRequestPostManualSendParams = {
  recipients: TcustomerInfo[];
  title: string;
  contents: string;
  isSendNow: boolean;
  sendDate: string; // YYYY.MM.DD
  sendHour: string; // 00 ~ 23 (ex. 00, 01, 02, ..., 23)
  sendMinute: string; // 00, 10, 20, 30, 40, 50
};
export const postManualSend = async (props: TRequestPostManualSendParams) => {
  try {
    const URL = '/message/manual';
    const token = window.localStorage.getItem('accessToken') || '';
    const { data } = await baseAPI({ url: URL, method: 'POST', headers: { token }, data: { ...props } });
    return data;
  } catch (err) {
    const error = apiErrorHandler(err);
    return error;
  }
};

//// 2) 알림메시지 자동 설정
// 1. 알림메시지 자동설정 조회 (GET)
export type IRequestGetMessageAutoParams = {
  receiverType: string;
};
export type IResponseGetMessageAuto = {
  code: number | null;
  status: number | null; // 0: 비활성화, 1: 활성화
  receiver: string | null; // 'driver' | 'client'
  process: number | null; // 1: 시작, 2: 중간, 3: 완료, 4: 1차보고, 5: 최종보고
  title: string | null;
  trigger: string | null;
  contents: string | null;
  disabledSendTime: number | null; // 0: 비활성화, 1: 활성화
  sendStartTime: string | null;
  sendEndTime: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
  processStatus: string | null;
};
export const getMessageAuto = async (props: IRequestGetMessageAutoParams) => {
  try {
    const URL = '/message/auto';
    const token = window.localStorage.getItem('accessToken') || '';
    const { data } = await baseAPI({ url: URL, method: 'GET', headers: { token }, params: { ...props } });
    return data as IResponseGetMessageAuto[];
  } catch (err) {
    const error = apiErrorHandler(err);
    return error;
  }
};
// 2. 주문 상태 토글 변경 시 요청 + 자동설정 발송예외 시간 설정저장하기(PATCH)
export type IRequestPatchMessageAutoParams = {
  id: number | string; // 쿼리스트링(messageId)
  isException: boolean; // 발송예외 설정 여부
  isUse: boolean; // 주문 상태 토글 여부
  exceptionTime: string; // 00:00-23:59
};
export const patchMessageAuto = async (props: IRequestPatchMessageAutoParams) => {
  try {
    const URL = `/message/auto/${props.id}`;
    const token = window.localStorage.getItem('accessToken') || '';
    const { data } = await baseAPI({
      url: URL,
      method: 'PATCH',
      headers: { token },
      data: {
        isException: props.isException,
        isUse: props.isUse,
        exceptionTime: props.exceptionTime,
      },
    });
    return data;
  } catch (err) {
    const error = apiErrorHandler(err);
    return error;
  }
};
//// 3) 발송 이력 조회
// 1. 자동발송 & 발송제외 (GET)
export type IRequestGetMessageAutoHistoryParams = {
  type?: string; // 'messageTitle' | 'consigneeName'
  keyword?: string;
  sendDatetime: string; // YYYYMMDD-YYYYMMDD
  isException?: boolean; // true 발송예외 요청
};
export type IResponseGetMessageAutoHistory = {
  messageAutoHistoryId: number | null; // 메시지 아이디
  messageAutoSettingId: number | null;
  requestId: string | null; //
  sendStatus: string | null; //
  orderId: number | null;
  processStatus: string | null;
  createdAt: string | null; // 발송일 (sendDate 로 처리)
  messageTitle: string | null; // 제목
  messageContents: string | null; // 내용
  isException: number | null;
  teamId: number | null;
  exceptionStartTime: string | null; // 00:00-23:59
  exceptionEndTime: string | null; // 00:00-23:59
  receiverType: string | null; //수신인 종류 'driver' | 'client'
  receiverName: string | null; // 수신인 이름
  receiverPhone: string | null; // 수신인 전화번호
};
export const getMessageAutoHistory = async (props: IRequestGetMessageAutoHistoryParams) => {
  try {
    const URL = '/message/auto/history';
    const token = window.localStorage.getItem('accessToken') || '';
    const { data } = await baseAPI({ url: URL, method: 'GET', headers: { token }, params: { ...props } });
    return data;
  } catch (err) {
    const error = apiErrorHandler(err);
    return error;
  }
};
// 2. 수동(예약발송) 이력 조회 (GET)
export type IRequestGetMessageManualHistoryParams = {
  type?: string; // 'messageTitle' | 'consigneeName'
  keyword?: string;
  sendDatetime: string; // YYYYMMDD-YYYYMMDD
};
export type IResponseMessageReceiver = {
  messageReceiverId: number | null;
  messageId: number | null;
  consigneeName: string | null;
  consigneePhone: string | null;
  createdAt: string | null;
};
export type IResponseGetMessageManualHistory = {
  messageId: number | null; // 메시지 ID
  teamId: number | null; // 팀 ID
  requestId: number | string | null; //
  sendStatus: number | string | null; //발송상태
  sendMode: boolean; // 수정하기 여부?
  reserveDatetime: string | null; // 발송일 (sendDate)
  createdBy: string | null; //
  updatedAt: string | null; //
  createdAt: string | null; //
  updatedBy: string | null; //
  messageTitle: string | null; // 제목
  messageContents: string | null; // 내용
  messageReceivers: IResponseMessageReceiver[]; // 수신인 정보 목록 + 수신인 이름 + 외 ~명
};
export const getMessageManualHistory = async (props: IRequestGetMessageManualHistoryParams) => {
  try {
    const URL = '/message/manual/history';
    const token = window.localStorage.getItem('accessToken') || '';
    const { data } = await baseAPI({ url: URL, method: 'GET', headers: { token }, params: { ...props } });
    return data;
  } catch (err) {
    const error = apiErrorHandler(err);
    return error;
  }
};
// 3. 예약 발송 취소 요청 (DELETE)
type IRequestDeleteMessageManualParams = {
  id: number | string; // 쿼리스트링(messageId)
};
export const deleteMessageManual = async (props: IRequestDeleteMessageManualParams) => {
  try {
    const URL = `/message/manual/${props.id}`;
    const token = window.localStorage.getItem('accessToken') || '';
    const { data } = await baseAPI({ url: URL, method: 'DELETE', headers: { token } });
    return data;
  } catch (err) {
    const error = apiErrorHandler(err);
    return error;
  }
};
// 4. 수정 완료 요청 (PATCH)
type IRequestPatchMessageManualParams = {
  id: number | string; // 쿼리스트링(messageId)
  receivers: { consigneeName: string; consigneePhone: string }[];
  messageTitle: string;
  messageContents: string;
  sendMode: boolean;
  reserveDatetime: string; //YYYY-MM-DD HH:mm
};
export const patchMessageManual = async (props: IRequestPatchMessageManualParams) => {
  try {
    const URL = `/message/manual/${props.id}`;
    const token = window.localStorage.getItem('accessToken') || '';
    const { data } = await baseAPI({
      url: URL,
      method: 'PATCH',
      headers: { token },
      data: {
        receivers: props.receivers,
        messageTitle: props.messageTitle,
        messageContents: props.messageContents,
        sendMode: props.sendMode,
        reserveDatetime: props.reserveDatetime,
      },
    });
    return data;
  } catch (err) {
    const error = apiErrorHandler(err);
    return error;
  }
};
